// Generated by CoffeeScript 2.7.0
var Admin__TagGroupsController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import TagGroupsSidebar from 'trunks/vue/admin/compositions/tags_groups/tags_group_sidebar.js';

import TagsList from 'trunks/vue/admin/compositions/tags_groups/tags_list.js';

export default Admin__TagGroupsController = (function() {
  class Admin__TagGroupsController extends Skylark.App.BaseController {
    index() {
      this._getActiveTab();
      this._generateTagGroupsSidebar(this.activeTab, '');
      return this._generateTagsList(this.activeTab, '');
    }

    show() {
      this._getActiveTab();
      this._generateTagGroupsSidebar(this.activeTab, this.getIds()[0]);
      return this._generateTagsList(this.activeTab, this.getIds()[0]);
    }

    _getActiveTab() {
      if (location.href.indexOf('receipt') > -1) {
        return this.activeTab = 'receipt';
      } else {
        return this.activeTab = 'user';
      }
    }

    _generateTagsList(activeTab, id) {
      var tags_group_container;
      tags_group_container = DomMaster.find("#tags_group_container").node;
      return new TagsList({
        el: tags_group_container,
        propsData: {
          activeTab: activeTab,
          selectedTagsGroupId: id
        }
      });
    }

  };

  Admin__TagGroupsController.include(GenerateMorePopover);

  Admin__TagGroupsController.include(TagGroupsSidebar);

  return Admin__TagGroupsController;

}).call(this);
